import React from 'react';
import { MessageOutlined } from '@ant-design/icons';

const Messages = () => (
    <section className="flex min-h-[60vh] items-center justify-center px-5 text-center">
        <div className="rounded-3xl bg-white px-8 py-10 shadow-sm">
            <MessageOutlined className="mb-4 text-4xl text-blue-500" />
            <h1 className="m-0 text-xl font-bold text-gray-800">Сообщения</h1>
            <p className="mb-0 mt-2 text-sm text-gray-500">
                Раздел сообщений пока пуст
            </p>
        </div>
    </section>
);

export default Messages;
